import { Localization } from '@mui/material/locale';
import { createTheme, ThemeProvider } from '@mui/material/styles';

const pageLang = document.querySelector('html')?.getAttribute('lang') || 'en';

let lang: Localization;
switch (pageLang) {
  case 'cs': {
    lang = require('@mui/material/locale').csCZ;
    break;
  }

  default: {
    lang = require('@mui/material/locale').enUS;
    break;
  }
}


const theme = createTheme(
	{
		components: {
			MuiTextField: {
				defaultProps: {
					variant: 'outlined',
				},
			},
			MuiInputLabel: {
				defaultProps: {
					shrink: true,
				},
			},
			MuiLink: {
				defaultProps: {
					underline: 'hover',
				},
			},
			MuiButton: {
				styleOverrides: {
					root: {
						'&::before': {
							content: "none",
						}
					}
				}
			}
		},
		typography: {
		},
		palette: {
			success: {
				main: '#bac778',
				contrastText: '#bac000',
			},
			primary: {
				main: '#0e1f3e',
				contrastText: '#FFF',
			},
			secondary: {
				main: '#FFF',
				contrastText: '#000',
			},
			text: {
				primary: '#000000',
				secondary: '#7e7e7e',
			},
		},
	},
	lang
);

interface ProviderProps {
  children: React.ReactNode[] | React.ReactNode;
}

const EdocatThemeProvider = (props: ProviderProps) => {
  return <ThemeProvider theme={theme}>{props.children}</ThemeProvider>;
};

export default EdocatThemeProvider;
